import filesApiService from '@/services/api/Files'

const CATEGORY_PHOTO = 'photo'
const CATEGORY_DOCUMENT = 'document'

const TYPE_YACHT_MODEL = 'App\\YachtModel'
const TYPE_SERVICE_TASK = 'App\\ServiceTask'

class File {
  constructor() {
    this.api = filesApiService

    this.CATEGORY_PHOTO = CATEGORY_PHOTO
    this.CATEGORY_DOCUMENT = CATEGORY_DOCUMENT
    this.TYPE_YACHT_MODEL = TYPE_YACHT_MODEL
    this.TYPE_SERVICE_TASK = TYPE_SERVICE_TASK
  }
}

const file = new File()

export default file
